import { TemplateRef } from '@angular/core';

export interface ModalData<T = undefined> {
  headerText?: string;
  template: TemplateRef<any>;
  context?: T;
}

export interface ModalOptions {
  width?: number;
  disableClose: boolean;
  panelClass?: string | string[];
  id?: string;
}
